export default "__VITE_ASSET__o$D7IsTy__"